import { FormLabel } from "@repo/ui";
import { FaAsterisk } from "react-icons/fa";
export function Label({ label, isRequired, style }) {
  return (
    <FormLabel>
      <div
        className={isRequired ? "label-required" : ""}
        style={style ? style : {}}
      >
        {label}
      </div>
    </FormLabel>
  );
}
